import { render, staticRenderFns } from "./StartEventProps.vue?vue&type=template&id=6ab43562"
import script from "./StartEventProps.vue?vue&type=script&lang=js"
export * from "./StartEventProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports